/**
 * 轻量 toast（固定底部提示），全站共用。
 * 样式类 .opc-token-toast 定义于 shared.scss。
 */
let toastTimer: ReturnType<typeof setTimeout> | null = null;

export function showToast(message: string) {
  if (typeof document === "undefined") return;
  let el = document.getElementById("opcTokenToast");
  if (!el) {
    el = document.createElement("div");
    el.id = "opcTokenToast";
    el.className = "opc-token-toast";
    el.setAttribute("role", "status");
    el.setAttribute("aria-live", "polite");
    document.body.appendChild(el);
  }
  el.textContent = message;
  el.classList.add("is-show");
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el && el.classList.remove("is-show"), 2600);
}
